import React, { useContext } from 'react';
import { useTheme } from '@mui/material/styles';
import { UiContext } from 'shared/lib/contexts/uiContext';
import cx from 'classnames';
import { defaultSpacingPresets } from 'shared/hooks/useGetSpacing';
import { IconProps } from 'shared/icons/iconProps';

export default function IconOk({
  extColor,
  isAutoscallable = true,
  sizeKey = '16x16',
  onClick,
  style,
}: IconProps) {
  const theme = useTheme();
  const fill = extColor || theme.palette.text.primary;
  const {
    spacings: {
      icons: { [sizeKey]: size },
    },
  } = useContext(UiContext);

  const w = isAutoscallable ? size.w : defaultSpacingPresets.icons[sizeKey].w;
  const h = isAutoscallable ? size.h : defaultSpacingPresets.icons[sizeKey].h;

  return (
    <svg
      className={cx('icon', { 'icon-disabled': !onClick })}
      onClick={onClick}
      style={style}
      width={w}
      height={h}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M12.6673 4.66699L6.4451 11.3337L3.33398 8.00033"
        strokeWidth="2"
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
